import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import App from './components/App'
import { createLogger } from 'redux-logger'
import { applyMiddleware, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import sagas from './sagas'
import rootReducer from './reducers'
import * as serviceWorker from './serviceWorker'

const loggerMiddleware = createLogger()

const sagaMiddleware = createSagaMiddleware()

const store = createStore(rootReducer, applyMiddleware(sagaMiddleware,loggerMiddleware))

sagaMiddleware.run(sagas)

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
